module.exports = __webpack_public_path__ + "static/media/趋势拐点@2x.ff95f796.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/趋势拐点@2x.png
// module id = 1570
// module chunks = 0